// DrmPanelSectionRow.js
'use strict';
import { connect } from 'react-redux';

import getOperationData from '../selector/getOperationData.js';

import DrmPanelSectionRow from '../component/DrmPanelSectionRow.jsx';

const mapStateToProps = (state, { keySystem, robustness }) => {
  return {
    drmTestResult: getOperationData(
      state,
      ['drm', 'testResult', keySystem],
      robustness
    ),
    testingTestcase: getOperationData(state, ['drm'], 'testingTestcase'),
  };
};

export default connect(mapStateToProps, null)(DrmPanelSectionRow);
